import React,  { useEffect, useState } from 'react';
import {
  Card,
  Col,
  Row,
  Button,
  Container,
  FormCheckbox
} from "shards-react";
import Table from './Table';
import { useLocation, useHistory } from "react-router-dom";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { setDateForTable } from '../../utils/date';
import {default as queryString} from "qs";
import { formatNumberAmount, parsingUserProfileSavingObject } from '../../utils/general';
import { SUBSCRIBER_BILLING_ADMIN, SUBSCRIBER_SYNC_TYPE } from '../../utils/constants';
import CRBadge from '../common/CRBadge';
function PerksInfo({
  formData,
  changeRequestedFields = {},
  userProfile,
  formDataRef,
  sectionformDataRef,
  clientMarkups,
  setFormData,
  syncApi,
  attachApi,
  setAlert,
  userRole,
  saveUserProfile,
  roleSelected,
  confirmAlert,
  setConfirmAlert,
  setAutoSaved,
}) {

  const [viewHistory, setViewHistory] = useState(false);
  const [isDisabledHSA, disableHSA] = useState(false);
  const location = useLocation();
  const history = useHistory();
  let queryParams = queryString.parse(location.search.replace("?", ""))
  
  const [disabledAttachPayItem, setDisabledAttachPayItem] = 
      useState(userRole?.selectedrole === SUBSCRIBER_BILLING_ADMIN.ADMIN || userRole?.selectedrole === SUBSCRIBER_BILLING_ADMIN.BILLING);

  const onChangeSync = async (HSAId, isChecked) => {
    if (!isChecked) {
      //Need to check it records is being saved in backend
      compareHSAInfoForSaving(HSAId);
    }
  }

  const onEditHSA = (row) => {
    history.push({
      pathname: `/HSA-info-form`,
      search:`?role=${queryParams.role}`,
      state: { userProfile, role: queryParams.role, row, formData, formDataRef, sectionformDataRef, clientMarkups, changeRequestedFields }
    });
  }

  const removingObject = (refNum)=>{
    let currentForms = formData.HSAInfos;
    let revisedArray = currentForms.filter(x => x.HSAId !== refNum);
    let formRevised = {...formData}
    formRevised.HSAInfos = revisedArray;
    setFormData({... formRevised})
  }

  const onDeleteHSA = (row) => {
    setConfirmAlert({
      ...confirmAlert,
      confirmMsg: 'Deleting this HSA cannot be undone. Do you wish to proceed, Yes or No?',
      visible: true,
      onConfirm: async () => {
        setConfirmAlert({ ...confirmAlert, visible: false })
        removingObject(row.HSAId);
      }
    })
  }
  
  const hasRecordCR = (recordId) =>
    recordId != null && Object.keys(changeRequestedFields).some(k => k.startsWith(`hsainfos[${recordId}].`));

  const tableColumns = [
    {
      Header: <span className="text-wrap">HSA Provider</span>,
      accessor: "HSAProvider",
      maxWidth: 110,
      minWidth: 110,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",

    },
    {
      Header: <span className="text-wrap">HSA Start Date</span>,
      accessor: "HSAStartDate",
      maxWidth: 110,
      minWidth: 110,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",
      cell: (row) => setDateForTable(row.HSAStartDate)
    },
    {
      Header: <span className="text-wrap">HSA End Date</span>,
      accessor: "HSAEndDate",
      maxWidth: 110,
      minWidth: 110,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",
      cell: (row) => setDateForTable(row.HSAEndDate)
    },
    {
      Header: <span className="text-wrap">HSA Contribution Frequency</span>,
      accessor: "frequency",
      maxWidth: 203,
      minWidth: 203,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",
    },

    {
      Header: <span className="text-wrap">HSA Contribution Currency</span>,
      accessor: "HSAContributionCurrency",
      maxWidth: 192,
      minWidth: 192,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",

    },

    {
      Header: <span className="text-wrap">HSA Contribution Amount</span>,
      accessor: "HSAAmount",
      maxWidth: 187,
      minWidth: 187,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-right",
      cell : row=>formatNumberAmount(row.HSAAmount, "en-US", 2, 2)
    },
    {
      Header: <span className="text-wrap">Sync Pay Item</span>,
      accessor: "syncPayItem",
      maxWidth: 70,
      minWidth: 70,
      className: "justify-content-center text-center text-break",
      bodyClassName: "justify-content-center text-center",
      cell : row => <div className={"d-flex justify-content-center text-bold " + ( Number(row.syncPayItem) === 1 ? "text-success" : "text-danger" )} >
        <FormCheckbox checked={ Number(row.syncPayItem) === 1 ?? false } 
          onChange={() => { if(disabledAttachPayItem){
              onChangeSync(row.HSAId, Number(row.syncPayItem) === 1 ?? false) 
            }
            else 
              return false;
          }}
        >
          { Number(row.syncPayItem) === 1 ? 'Synced' : 'Not Synced'}
        </FormCheckbox></div>
    },
    {
      Header: <span className="text-wrap">Action</span>,
      accessor: "HSAId",
      maxWidth: 50,
      minWidth: 50,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",
      cell: (row) => (
        <span>{hasRecordCR(row.recordId) && <CRBadge />}<img src="./icons/edit-square.svg" role="button" height="17.5" width="17.5" className="mr-2" onClick={() => {
          onEditHSA(row);
        }}></img>
        <img role="button" src="./icons/cross-icon.png" height="17.5" width="17.5" onClick={() =>
          onDeleteHSA(row)}>
        </img></span>
        // <Link to={{ pathname: `/HSA-info-form`, search:`?role=${queryParams.role}`, state: { userProfile, role: queryParams.role, row, formData, formDataRef, sectionformDataRef, clientMarkups } }}>{row.HSAId == 0 ? 'New' : row.HSAId}</Link>
      )
    },
  ];

  const togleHistory = () => {
    setViewHistory(!viewHistory);

  }

  useEffect(()=>{

    if(formData.HSAApplicable === 'Yes'){
      disableHSA(true); 
    }

  },[formData])

  ///----> Compare and Saving part <----///
  
  const compareHSAInfoForSaving = async (refNumber) => {
    if (formData.HSAInfos.length > sectionformDataRef.HSAInfos.length) {
      setConfirmAlert({
        ...confirmAlert,
        confirmMsg: 'HSA is not saved. Would you like to save it now?',
        visible: true,
        onConfirm: async () => {

          setConfirmAlert({ ...confirmAlert, visible: false })
          setAutoSaved(true);
          let profileSaved = await parseModuleObjectForSave();
          if (profileSaved) {
            syncPayItemWithUser(refNumber);
            setAutoSaved(false);
          }
        }
      })
    }
    else {
      syncPayItemWithUser(refNumber);
    }
  }

  async function parseModuleObjectForSave() {
    let savingObject = parsingUserProfileSavingObject(formData, sectionformDataRef, formDataRef, roleSelected);
    if (savingObject !== undefined && savingObject.flag) {
      let response = await saveUserProfile(savingObject.finalData);
      return response;
    }
    else {
      setAlert(savingObject.errorMessage, "danger");
      return savingObject.flag;
    }
  }

  const syncPayItemWithUser = async (HSAId) => {
    //call an API 
    let response = await syncApi(formData.userId, SUBSCRIBER_SYNC_TYPE.HSA, HSAId );

    if (response) {
      formData.HSAInfos = formData.HSAInfos.map((x) => {
        //if(x.HSAId === HSAId){
          x.syncPayItem = 1;
          x.payItemRefNum = response;
        //}
        return x;
      })
      setFormData({ ...formData })

      sectionformDataRef.HSAInfos = sectionformDataRef.HSAInfos.map((x) => {
        //if (x.HSAId === HSAId) {
          x.syncPayItem = 1;
          x.payItemRefNum = response;
        //}
        return x;
      })
    } 
  }

  /// ---- > End < ---- ///

  const hsaCREntries = Object.entries(changeRequestedFields).filter(([k]) => k.startsWith('hsainfos'));
  const hsaHasCR = hsaCREntries.length > 0;
  const hsaCRTooltip = hsaCREntries.map(([k, v]) => `${k.split('.')[1]}: ${v.newValue ?? '-'}`).join(', ');

  return (
    <Card id="perks" small

      className="mb-5 w-100 d-flex personalParent">
      <span className="iconBox"><i className="fa-solid fa-gift iconStyle" /></span>
      <h4 className="m-0 section-title headerStyle pr-0">Health Spending Account Information <spen className="d-inline" ><FormCheckbox id="history" name="history"
        className="d-inline"
        checked={isDisabledHSA} onChange={() => {
          formData.HSAApplicable = formData.HSAApplicable == 'Yes' ? 'No' :'Yes';
          disableHSA(!isDisabledHSA)
        }}
        toggle small></FormCheckbox></spen></h4>
      
      <Container fluid className="file-manager__filters border-bottom">
        <Row className="mb-4">

          <Col lg="10"
            className="d-flex flex-row-reverse">

            <div className='d-flex flex-column ml-3 section-card-header'>
              <spen className="header-checkbox">
                <FormCheckbox id="history" name="history"
                  checked={viewHistory} onChange={togleHistory}
                  toggle small><spen className="font-weight-bold text-center">View HSA History</spen></FormCheckbox>
              </spen>
              <spen className="font-weight-bold text-center">


              </spen>
              <spen className="font-weight-bold font-italic">Note - Highlighted in blue row is the active HSA information.</spen>
            </div>
            <div></div>

          </Col>
          
          <Col lg="2"
            className=" pt-0 pl-0 pb-0 pr-2 file-manager__filters__search d-flex align-items-center justify-content-center justify-content-md-end col-6" >

<Button disabled={!isDisabledHSA} className="my-2 py-2 pr-0 pl-0 mx-2 w-100" size='sm'
                theme="accent"
                onClick={() => { 

                  history.push({
                    pathname: `/HSA-info-form`,
                    search:`?role=${queryParams.role}`,
                    state: {
                      userProfile,
                      refNum: 0,
                      role:queryParams.role,
                      formData,
                      formDataRef,
                      sectionformDataRef,
                      clientMarkups,
                      changeRequestedFields
                    },
                  });
                }}
                ><spen>Add HSA</spen></Button>
            {hsaHasCR && (
              <div className="text-right mt-1">
                <CRBadge newValue={hsaCRTooltip} placement="left" />
              </div>
            )}

          </Col>

        </Row>
       

        <div className='scrollabe-table-container'>
          {

            (formData && formData.HSAInfos) ? 
              (<Table headers={tableColumns} rows={formData.HSAInfos.filter(x => x.HSAId !== 0)} viewHistory={viewHistory} />)
             :
              (<Table headers={tableColumns} rows={[]} viewHistory={viewHistory} />)
          }
        </div>
      </Container>




    </Card>
  );
}

export default PerksInfo;
